import React, {useContext, useEffect, useRef, useState} from 'react';
import {AppContext} from '../../../../../AppModule/Context';
import VIDABOO_CONSTANTS from '../../../../../config/consts';
import httpService from '../../../../../services/restServices/httpService';
import ToastWrapperComponentRender from './toastWrapperComponentRender';

const ToastWrapperComponent = () => {
  const context = useContext(AppContext);
  const contextToastData = useRef(context.toastData); //using this to handle missing updated context data in setTimeout
  const [modifiedToastData, setModifiedToastData] = useState([]);

  useEffect(() => {
    httpService.initShowToast(handleHttpServiceToast);
  }, []);

  useEffect(() => {
    contextToastData.current = [...context.toastData];
  }, [context.toastData]);

  useEffect(() => {
    let toastData = [...context.toastData];
    toastData.forEach((toastObj, idx) => {
      //if timeoutId is present in toastObj -> this means that toast is already handled
      if (!toastObj.timeoutId) {
        if (toastObj.isSticky) {
          toastObj.idx = idx;
          toastObj.onDismiss = () => {
            clearToastById(toastObj.toastId);
          };
          if (toastObj.shouldRemoveToastAutomatically) {
            const timeoutId = setTimeout(() => {
              clearToastById(toastObj.toastId);
            }, VIDABOO_CONSTANTS.TOAST_MESSAGE_TIMES.MAX_TIME);
            toastObj.timeoutId = timeoutId;
          }
        } else {
          if (toastObj.toastCustomBtnTxt) {
            toastObj.idx = idx;
            toastObj.onDismiss = () => {
              clearToastById(toastObj.toastId);
            };
          }
          const timeoutId = setTimeout(
            () => {
              clearToastById(toastObj.toastId);
            },
            toastObj?.toastLongDuration
              ? VIDABOO_CONSTANTS.TOAST_MESSAGE_TIMES.LONG_TIME
              : VIDABOO_CONSTANTS.TOAST_MESSAGE_TIMES.MIN_TIME,
          );
          toastObj.timeoutId = timeoutId;
          toastObj.idx = idx;
        }
      }
    });
    setModifiedToastData(toastData);
  }, [context.toastData]);

  const handleHttpServiceToast = (toastObj) => {
    context.addToastObj(toastObj);
  };

  const clearToastById = (toastId) => {
    context.removeToastByToastId(toastId);
  };

  return <ToastWrapperComponentRender modifiedToastData={modifiedToastData} />;
};

export default ToastWrapperComponent;
